const { REACT_APP_REST_ENDPOINT } = process.env;
const SPEDIZIONE_ENDPOINT = `${REACT_APP_REST_ENDPOINT}/attestato-spedizione`;

const AttestatoSpedizioneService = {

    _handleJsonResponse: async (response) => {
        if (response.ok) {
            const text = await response.text();
            return text ? JSON.parse(text) : {};
        } else {
            const error = await response.json().catch(() => ({ message: `Errore del server: ${response.statusText}` }));
            throw new Error(error.message || "Si è verificato un errore");
        }
    },

        saveSpedizione(formData) {
            const token = localStorage.getItem("token");
            return fetch(`${SPEDIZIONE_ENDPOINT}/save`, {
                method: 'POST',
                headers: {
                    // Specifichiamo che stiamo inviando dati in formato JSON
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                // --- CORREZIONE DEFINITIVA QUI ---
                // Convertiamo l'oggetto JavaScript in una stringa JSON
                body: JSON.stringify(formData)
            }).then(this._handleJsonResponse);
        }
};

export default AttestatoSpedizioneService;